document.addEventListener('DOMContentLoaded', function() {
  var cookieLink = document.getElementById('cookie-consent-preferences-link');
  if (cookieLink) {
    cookieLink.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var cookies = ['tracking_consent', 'tracking_consent_v2', 'user_consent', '_shopify_consent'];
      cookies.forEach(function(name) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=' + window.location.hostname;
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
      });
      if (window.Shopify && window.Shopify.customerPrivacy) {
        window.Shopify.customerPrivacy.openBanner();
      } else {
        window.location.reload();
      }
    });
  }
});
